export default "__VITE_ASSET__5Svmc3ix__"